import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic as Mi } from "../../../../styles";
export const StyledSectionTitleGrid = styled(Grid) `
	margin-bottom: ${Mi.spacer06};
`;
//# sourceMappingURL=VehicleAttributesSection.style.js.map